import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/admin/city-intelligence")({
  component: () => <Navigate to="/admin/cities" replace />,
});
